import React from 'react';

interface SeenReceiptProps {
    /** True once the other side has opened the chat on/after this message was sent. */
    seen: boolean;
}

/**
 * WhatsApp-style double-checkmark: gray = sent, blue = seen by the other side.
 * Rendered only for messages authored by "my" side (see MessageBubble).
 */
const SeenReceipt: React.FC<SeenReceiptProps> = ({ seen }) => (
    <svg
        viewBox="0 0 16 10"
        className={`w-3.5 h-2.5 shrink-0 ${seen ? 'text-blue-600' : 'text-gray-400'}`}
        fill="none"
        role="img"
        aria-label={seen ? 'Seen' : 'Sent'}
    >
        <path
            d="M1 5L4.5 8.5L9 2"
            stroke="currentColor"
            strokeWidth="1.4"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M6 5L9.5 8.5L15 2"
            stroke="currentColor"
            strokeWidth="1.4"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

export { SeenReceipt };
